import { __decorate, __rest } from "tslib";
/**
 * 预展中车辆
 * */
import React, { Component } from 'react';
import { Table, Form, DatePicker, Modal, Row, Col } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, OperateShowMore } from '@/components/index';
import { dispatch } from '@@/store';
import { dealListValueShow, dealTimeAnotherLine, dealValueShow } from '@/shared/functions';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import moment from 'moment';
import { dealTableScroll } from '@/pages/CarManage/_components/function';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
// @ts-ignore
let PreviewCar = class PreviewCar extends Component {
    constructor(props) {
        super(props);
        // desc 下架
        this.offShelf = (data) => {
            const { auctionMode, auctionStatus } = data;
            // 暗拍 竞拍中 | （超级拍（现场拍）| 超级拍（车道拍） 投标中）先判断是否出价超过保留价，如超过提示用户[该车辆出价已经超过保留价了，是否确定下架该车辆]，再调用流拍接口；否则直接调用；
            // 暗拍 预展中，下架接口；
            // 现场拍和车道拍，下架接口；
            const superAuction = [1011, 1021];
            if ((auctionMode === 2 && auctionStatus === 3) || (superAuction.includes(auctionMode) && auctionStatus === 9)) {
                dispatch.carOperate.checkCanOutOfStock(data).then((ifOver) => {
                    Modal.confirm({
                        title: `${ifOver ? '该车辆出价已经超过保留价了，是否确定下架该车辆' : '是否确定下架该车辆？'}`,
                        onOk() {
                            dispatch.carOperate.abortive(Object.assign(Object.assign({}, data), { callback: () => {
                                    dispatch.carOperate.abortive(data);
                                    dispatch.carState.getEveryStateCarNum({});
                                } }));
                        },
                    });
                });
                return;
            }
            Modal.confirm({
                title: '是否确定下架该车辆？',
                onOk() {
                    dispatch.carOperate.offShelf({
                        auctionId: data.auctionIdStr,
                        callback: () => {
                            dispatch.carState.updateAuction(0);
                            dispatch.carState.getEveryStateCarNum({});
                        },
                    });
                },
            });
        };
        this.state = {
            clipped: [
                { dataIndex: 'carmodelName' },
                { dataIndex: 'vin' },
                { dataIndex: 'license' },
                { dataIndex: 'locationName' },
                { dataIndex: 'buyPriceY' },
                { dataIndex: 'basePriceY' },
                { dataIndex: 'highestOfferY' },
                { dataIndex: 'times' },
            ],
            colums: [
                {
                    title: '车辆信息',
                    dataIndex: 'carMsg',
                    fixed: 'left',
                    width: 400,
                    render: (data, record) => {
                        const { reportResultType, goodsIdStr, carmodelName, firstImage, vin, license, locationName, rankDesc, rankLevel } = record;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={carmodelName}/>
                </div>
                <div>
                  <div>
                    <a onClick={() => {
                            showCarDetail(goodsIdStr);
                        }}>
                      {carmodelName}
                    </a>
                  </div>
                  <div>{`VIN码：${dealValueShow(vin)}`}</div>
                  <div>
                    {reportResultType === 1 && (<img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>)}
                    <div className={'tag_item'}>{license}</div>
                    <div className={'tag_item'}>{locationName}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'sellerName',
                    width: 150,
                    render: (sellerName, record) => {
                        return sellerName ?
                            (<a onClick={() => {
                                showInfo('seller', record.sellerCode);
                            }}>
                  {sellerName}
                </a>) : fontEndConfig.noValueReplace;
                    },
                },
                {
                    title: '价格信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'priceMsg',
                    width: 200,
                    render(data, record) {
                        const { basePriceY } = record;
                        return (<div>
                
                <div>保留价：{basePriceY}</div>
              </div>);
                    },
                },
                {
                    title: '竞拍信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'auctionMsg',
                    width: 200,
                    render(data, record) {
                        const { highestOfferY } = record;
                        return (<div>
                <div>最高价：{highestOfferY}</div>
              </div>);
                    },
                },
                {
                    title: '上拍次数',
                    dataIndex: 'times',
                    width: 100,
                },
                {
                    title: '申请发拍时间',
                    dataIndex: 'createTime',
                    width: 150,
                    render: (createTime) => {
                        return createTime ? (dealTimeAnotherLine(createTime)) : fontEndConfig.noValueReplace;
                    },
                },
                {
                    title: '所在场次开拍时间',
                    dataIndex: 'preStartDate',
                    width: 150,
                    render: (preStartDate, rowData) => {
                        return preStartDate && rowData.preStartTime ? (dealTimeAnotherLine(`${preStartDate} ${rowData.preStartTime}`)) : fontEndConfig.noValueReplace;
                    },
                },
                {
                    title: '操作',
                    width: 100,
                    fixed: 'right',
                    dataIdex: 'operate',
                    render: (test, data) => {
                        return (<OperateShowMore>
                <a luban-id="PSGJB-BID-PMCL-YZXJ" onClick={() => {
                            this.offShelf(data);
                        }}>
                  下架
                </a>
              </OperateShowMore>);
                    },
                },
            ],
            globalSearch: {},
            privateSearch: {
                status: 1,
            },
        };
    }
    componentDidMount() {
        dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    updateTable(index) {
        dispatch.carState.updateAuction(index);
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const params = Object.assign(Object.assign({}, globalSearch), privateSearch);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        dispatch.carState.updateAuction(1);
    }
    searchData(searchData) {
        const { provinceCode, cityCode, sellerCode, sellerPhone } = searchData, otherSearchData = __rest(searchData, ["provinceCode", "cityCode", "sellerCode", "sellerPhone"]);
        this.setState({
            globalSearch: Object.assign(Object.assign({}, otherSearchData), { localProvinceCode: provinceCode, locationCode: cityCode, distributorContactNumber: sellerPhone, distributorCode: sellerCode }),
        }, () => {
            this.search();
        });
    }
    render() {
        const { tableData, tableTotal, pageIndex, pageSize, isLoading, auctionKey, searchData, } = this.props.carState;
        const { colums, clipped } = this.state;
        const { dealColumns, scrollX } = dealTableScroll(colums);
        return (<TableContainer exportObj={{
            type: 'auction',
            params: Object.assign(Object.assign({}, searchData), { exportType: 'auction_status_data' }),
            fileName: '车辆管理-预展中',
            allow: 'psgjb-carpendyuzhan-export',
        }}>
        <Row gutter={16} align={'middle'} type={'flex'} justify={'end'} style={{
            marginRight: '100px',
        }}>
          <Col span={8}>
            <Form.Item label={'申请发拍时间'} className={'search_time_label_border form_date_width_100'} colon={false}>
              <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = `${endTime.format('YYYY-MM-DD')} 23:59:59`);
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { preStartDate: startTime, preEndTime: endTime }),
            }, () => {
                this.search();
            });
        }}/>
            </Form.Item>
          </Col>
        </Row>
        <Table className={'draw_table_all_border scroll_table'} rowKey={auctionKey} loading={isLoading} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableData,
        })} scroll={{
            x: scrollX,
        }} pagination={{
            current: pageIndex,
            defaultPageSize: pageSize,
            showQuickJumper: true,
            showTotal: total => `共${total}条`,
            total: tableTotal,
            onChange: this.updateTable,
        }}/>
      </TableContainer>);
    }
};
PreviewCar = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], PreviewCar);
export default PreviewCar;
